import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {updatePageTitle} from "../store/slice/appSlice";

export const usePageTitle = (title: string) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updatePageTitle(title));
    }, [title, dispatch]);
}